import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { Fonts } from "shared/constants/AppEnums";
import { PlanData } from "types/models/planMaster/planMasterApp";

interface PlanProps {
  plan: PlanData;
  onBack?: () => void;
}

const PlanUpdateHeader: React.FC<PlanProps> = ({ plan, onBack }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    }
    navigate("/planMaster/ViewPlan");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBackClick}
          sx={{
            textTransform: "none",
            color: "black",
            padding: 0,
            minWidth: "auto",
          }}
        />
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            ml: 0.5,
            mb: { xs: 1, sm: 0 },
          }}
        >
          {plan.planId ? "Edit Plan" : "Add New Plan"}
        </Box>
      </Box>
    </Box>
  );
};

export default PlanUpdateHeader;
